import * as types from "../actions/types/payments.types";

const initialState = {
    getBeneficiariesState: "loading",
    beneficairiesList: [],
    selectedBeneficiaryData: {},
    schedulePaymentState: "idle",
    beneficiaryBankData: {
        bankCode: "",
        bankName: "",
        iconUrl: "",
        accountNumber: "",
    },
    processTransferState: "idle",
    verifyAccState: "initial",
    verifyAccountData: {
        beneficiaryAccountNumber: "",
        beneficiaryBankCode: null,
        beneficiaryCustomerID: 0,
        beneficiaryName: "",
        isSuccessful: false,
        message: "",
        nameEnquiryID: 0,
        responseCode: "",
        senderAccountNumber: null,
        senderName: null,
        sessionID: "",
        transferCharge: 0,
    },
    viewPackage: false,
    viewAmount: false,
    viewSendMoneyAccount: false,
    transactionOngoing: false,
    comingFromManageBeneficiaries: false,
    deleteBeneficiaryState: "idle",
    addBeneficiaryState: "idle",
    reloadBeneficiary: false,
    schedulePaymentsInfo: {
        startDate: "",
        endDate: "",
        paymentScheduleFrequency: "",
    },
    comingFromManageBeneficiariesData: {},
    initiateTransferState: "idle",
    initiateTransferData: {},
    requestApprovalState: "idle",
    sourceBalanceState: "idle",
    sourceAccountBalance: {},
    bankList: [],
};

export const paymentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.VIEW_SEND_MONEY_ACCOUNT:
            return {
                ...state,
                viewSendMoneyAccount: true,
            };
        case types.HIDE_SEND_MONEY_ACCOUNT:
            return {
                ...state,
                viewSendMoneyAccount: false,
            };
        case types.SET_BENEFICIARY_SWITCH_CLICK:
            return {
                ...state,
            };
        case types.VERIFY_ACCOUNT_STARTED:
            return {
                ...state,
                verifyAccState: "loading",
            };
        case types.VERIFY_ACCOUNT_SUCCEDEED:
            return {
                ...state,
                verifyAccState: "success",
                verifyAccountData: {
                    ...state.verifyAccountData,
                    ...action.payload,
                    beneficiaryAccountNumber: action.payload.beneficiaryAccountNumber,
                    beneficiaryBankCode: action.payload.beneficiaryBankCode,
                    beneficiaryCustomerID: action.payload.beneficiaryCustomerID,
                    beneficiaryName: action.payload.beneficiaryName,
                    isSuccessful: action.payload.isSuccessful,
                    message: action.payload.message,
                    //nameEnquiryID: action.payload.nameEnquiryID,
                    responseCode: action.payload.responseCode,
                    senderAccountNumber: action.payload.senderAccountNumber,
                    senderName: action.payload.senderName,
                    sessionID: action.payload.sessionID,
                    transferCharge: action.payload.transferCharge,
                    beneficiaryBank: action.payload.beneficiaryBank,
                    beneficiaryAmount: action.payload.beneficiaryAmount,
                    beneficiaryIndex: action.payload.beneficiaryIndex,
                    beneficiaryKYCLevel: action.payload.beneficiaryKYCLevel,
                    beneficiaryBVN: action.payload.beneficiaryBVN,
                },
                verifyMessage: action.payload.message,
                selectedBeneficiaryData: {
                    ...state.selectedBeneficiaryData,
                    beneficiaryAccountNumber: action.payload.beneficiaryAccountNumber,
                    beneficiaryCustomerID: action.payload.beneficiaryCustomerID,
                    beneficiaryName: action.payload.beneficiaryName,
                    sessionID: action.payload.sessionID,
                    transferCharge: action.payload.transferCharge,
                    bankName: action.payload.beneficiaryBank,
                    bankCode: action.payload.beneficiaryBankCode,
                },
                beneficiaryBankData: {
                    ...state.beneficiaryBankData,
                    beneficiaryAccountNumber: action.payload.beneficiaryAccountNumber,
                    beneficiaryCustomerID: action.payload.beneficiaryCustomerID,
                    beneficiaryName: action.payload.beneficiaryName,
                    sessionID: action.payload.sessionID,
                    transferCharge: action.payload.transferCharge,
                    bankName: action.payload.beneficiaryBank,
                    bankCode: action.payload.beneficiaryBankCode,
                    accountNumber: action.payload.beneficiaryAccountNumber,
                    iconUrl: "",
                },
            };
        case types.VERIFY_ACCOUNT_FAILED:
            return {
                ...state,
                verifyAccState: "failed",
                verifyMessage: action.payload,
            };
        case types.RESET_BENEFICIARY_STATE:
            return {
                ...state,
                verifyAccState: "idle",
                verifyAccountData: {},
                verifyMessage: "",
                selectedBeneficiaryData: {},
                comingFromManageBeneficiaries: false,
            };
        case types.GET_BENEFICIARIES_STARTED:
            return {
                ...state,
                getBeneficiariesState: "loading",
            };
        case types.GET_BENEFICIARIES_SUCCEDEED:
            localStorage.setItem("kudaBeneficiaries", JSON.stringify(action.payload));
            return {
                ...state,
                getBeneficiariesState: "success",
                beneficairiesList: action.payload,
                reloadBeneficiary: false,
            };
        case types.GET_BENEFICIARIES_FAILED:
            return {
                ...state,
                getBeneficiariesState: "failed",
            };
        case types.SELECTED_BANK_DATA:
            return {
                ...state,
                beneficiaryBankData: {
                    ...state.beneficiaryBankData,
                    bankCode: action.payload.bankCode,
                    bankName: action.payload.bankName,
                    iconUrl: action.payload.iconUrl,
                    accountNumber: action.payload?.accountNumber,
                },
            };
        case types.ADD_PAYMENT_SCHEDULE_STARTED:
            return {
                ...state,
                schedulePaymentState: "loading",
            };
        case types.ADD_PAYMENT_SCHEDULE_SUCCEEDED:
            return {
                ...state,
                schedulePaymentState: "success",
            };
        case types.ADD_PAYMENT_SCHEDULE_FAILED:
            return {
                ...state,
                schedulePaymentState: "failed",
            };
        case types.INITIATE_TRANSFER_STARTED:
            return {
                ...state,
                initiateTransferState: "loading",
            };
        case types.INITIATE_TRANSFER_SUCCEDEED:
            return {
                ...state,
                initiateTransferState: "success",
                initiateTransferData: {
                    ...state.initiateTransferData,
                    ...action.payload,
                },
            };
        case types.INITIATE_TRANSFER_FAILED:
            return {
                ...state,
                initiateTransferState: "failed",
            };
        case types.PROCESS_TRANSFER_STARTED:
            return {
                ...state,
                processTransferState: "loading",
            };
        case types.PROCESS_TRANSFER_SUCCEEDED:
            return {
                ...state,
                processTransferState: "success",
            };
        case types.PROCESS_TRANSFER_FAILED:
            return {
                ...state,
                processTransferState: "failed",
            };
        case types.RESET_PAYMENTS:
            return {
                ...state,
                processTransferState: "initial",
                viewSendMoneyAccount: false,
                verifyAccState: "initial",
                verifyAccountData: {},
                beneficiaryBankData: {
                    ...state.beneficiaryBankData,
                    bankCode: "",
                    bankName: "",
                    iconUrl: "",
                    accountNumber: "",
                },
                schedulePaymentsInfo: {
                    startDate: "",
                    endDate: "",
                    paymentScheduleFrequency: "",
                },
            };
        case types.SET_FROM_BENEFICIARIES:
            return {
                ...state,
                comingFromManageBeneficiaries: action.payload,
            };

        case types.SET_BENEFICIARY_DATA:
            localStorage.setItem("selectedBeneficiary", JSON.stringify(action.payload));
            return {
                ...state,
                selectedBeneficiaryData: action.payload,
            };
        case types.ADD_BENEFICIARY_STARTED:
            return {
                ...state,
                addBeneficiaryState: "loading",
            };
        case types.ADD_BENEFICIARY_SUCCEDEED:
            return {
                ...state,
                addBeneficiaryState: "success",
                beneficairiesList: [...state.beneficairiesList, { ...action.payload.data }],
                comingFromManageBeneficiariesData:
                    action.payload.type === "beneficiaryPage" ? { ...action.payload.data } : null,
            };
        case types.ADD_BENEFICIARY_FAILED:
            return {
                ...state,
                addBeneficiaryState: "failed",
            };
        case types.DELETE_BENEFICIARY_STARTED:
            return {
                ...state,
                deleteBeneficiaryState: "loading",
            };
        case types.UPDATE_BENEFICIARIES_LIST:
            const beneficiariesList = state.beneficairiesList.map((item) => {
                if (item.id === action.payload.id) {
                    return {
                        ...item,
                        ...action.payload.data,
                    };
                }
                return item;
            });

            return {
                ...state,
                beneficairiesList: beneficiariesList,
            };

        case types.DELETE_BENEFICIARY_SUCCEDEED:
            return {
                ...state,
                deleteBeneficiaryState: "success",
                beneficairiesList: state.beneficairiesList.filter(
                    (item) => item.id !== action.payload,
                ),
            };
        case types.DELETE_BENEFICIARY_FAILED:
            return {
                ...state,
                deleteBeneficiaryState: "failed",
            };
        case types.RELOAD_BENEFICIARY:
            return {
                ...state,
                reloadBeneficiary: true,
            };
        case types.SET_SCHEDULE_FREQUENCY:
            return {
                ...state,
                schedulePaymentsInfo: {
                    ...state.schedulePaymentsInfo,
                    paymentScheduleFrequency: action.payload,
                },
            };
        case types.SET_PAYMENT_START_DATE:
            return {
                ...state,
                schedulePaymentsInfo: {
                    ...state.schedulePaymentsInfo,
                    startDate: action.payload,
                },
            };
        case types.SET_PAYMENT_END_DATE:
            return {
                ...state,
                schedulePaymentsInfo: {
                    ...state.schedulePaymentsInfo,
                    endDate: action.payload,
                },
            };
        case types.REQUEST_APPROVAL_STARTED:
            return {
                ...state,
                requestApprovalState: "loading",
            };
        case types.REQUEST_APPROVAL_SUCCEDEED:
            return {
                ...state,
                requestApprovalState: "success",
            };
        case types.REQUEST_APPROVAL_FAILED:
            return {
                ...state,
                requestApprovalState: "failed",
            };
        case types.FETCH_SOURCE_BALANCE_STARTED:
            return {
                ...state,
                sourceBalanceState: "loading",
            };
        case types.FETCH_SOURCE_BALANCE_SUCCEDEED:
            return {
                ...state,
                sourceAccountBalance: { ...state.sourceAccountBalance, ...action.payload.data },
                sourceBalanceState: "success",
            };
        case types.FETCH_SOURCE_BALANCE_FAILED:
            return {
                ...state,
                errorMessage: action.payload.message,
                sourceBalanceState: "failed",
            };
        case types.GET_BANK_LIST_SUCCEEDED:
            return {
                ...state,
                bankList: action.payload,
            };
        default:
            return state;
    }
};
